import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { StateLanguage } from '../../languages/config/StateLanguage';

import logo from '../../assets/themes/svg/logo-official.svg';
import background from '../../assets/themes/images/developing.svg';

export interface ComingSoonPageProps {};

const ComingSoonPage: React.FunctionComponent<ComingSoonPageProps> = props => {
  const {lang} = StateLanguage()
  const navigate = useNavigate()

  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  const handleOnClick = () => {
    navigate(-1)
  }

  useEffect( () => {
    let target: Date = new Date('2026-08-31T23:59:59Z')

    const interval = setInterval(() => {
      let current: Date = new Date()
      let difference: number = target.getTime() - current.getTime()
      let remainingDays: number = Math.floor(difference / (1000 * 60 * 60 * 24))
      let remainingHours: number = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let remainingMinutes: number = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      let remainingSeconds: number = Math.floor((difference % (1000 * 60)) / 1000)

      setDays(remainingDays)
      setHours(remainingHours)
      setMinutes(remainingMinutes)
      setSeconds(remainingSeconds)

      if (difference <= 0) {
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="d-flex flex-column flex-root h-100">
      <div className="d-flex flex-column flex-column-fluid">
        <div className="d-flex flex-column flex-column-fluid flex-center justify-content-start p-10">
          <div className="cursor-pointer">
            <img src={logo} alt={lang.labels.digitalAdmin} className="h-50px h-lg-75px mb-5" />
          </div>
          <div className="pt-5 mb-10 text-center">
            <h1 className="fs-3x text-capitalize mb-5">{lang.labels.comingSoon}</h1>
            <div className="fw-bold fs-3 text-muted">
              {lang.labels.thePageYouLookedNotFound}
              <br />
              {lang.labels.soonYouWillBeAbleToAccessNewFunctionalities}
            </div>
          </div>
          <div className="d-flex text-center mb-10">
            <div className="w-75px rounded-3 bg-body shadow p-5 mx-3">
              <div className="fs-2 fw-bolder">{days}</div>
              <div className="fs-7 fw-bold text-muted text-lowercase">{lang.labels.days}</div>
            </div>
            <div className="w-75px rounded-3 bg-body shadow p-5 mx-3">
              <div className="fs-2 fw-bolder">{hours}</div>
              <div className="fs-7 text-muted text-lowercase">{lang.labels.hrs}</div>
            </div>
            <div className="w-75px rounded-3 bg-body shadow p-5 mx-3">
              <div className="fs-2 fw-bolder">{minutes}</div>
              <div className="fs-7 text-muted text-lowercase">{lang.labels.min}</div>
            </div>
            <div className="w-75px rounded-3 bg-body shadow p-5 mx-3">
              <div className="fs-2 fw-bolder">{seconds}</div>
              <div className="fs-7 text-muted text-lowercase">{lang.labels.sec}</div>
            </div>
          </div>
          <div className="fw-bolder fs-2 text-muted mb-10">{lang.labels.weAreWorkingFeature}</div>
          <button className="btn btn-lg btn-primary text-nowrap mb-10" type="button" onClick={handleOnClick}>{lang.labels.goToPreviousPage}</button>
          <img src={background} alt="" className="h-250px h-md-200px" />
        </div>
      </div>
    </div>
  )
};

export default ComingSoonPage;
